module.exports = __webpack_public_path__ + "img/log-out.7151fa6d.svg";